<template>
  <div class="TEASER" :class="{mixedTeasers: mixedTeasers, NOmixedTeasers: !mixedTeasers}" >
    <!--selectionNo: {{selectionNo}}-->

    <div class="info msg all_corners" v-show="!selectionNo && currentBetSlipState<1" >
      <icon name="icon-information" colorName="blue"></icon>
      <span v-html="$t('BetSlip.tab.TEASER.emptyInfoMsg')"></span>
    </div>

    <div class="sport-container" v-for="(group, index) in teaserGroups" v-if="group.Selections"
         v-show="currentBetSlipState<1 || (currentBetSlipState>=1 && betTypeStakes[mixedTeasers ? group.IDFOSportType : index].PerBetType.A && selectedNo(mixedTeasers ? group.IDFOSportType : index)>1)"
         :class="{'info-msg-on':(teaserSelectionsPerTtype(mixedTeasers ? group.IDFOSportType : index)<2 || selectedNo(mixedTeasers ? group.IDFOSportType : index)<2) || (teaserSelectionsPerTtype(mixedTeasers ? group.IDFOSportType : index)>1 && selectedNo(mixedTeasers ? group.IDFOSportType : index)>1 && !allowedBetTypes.PRL[mixedTeasers ? group.IDFOSportType : index].length)}"
    >
      <div class="teaser-option-container">
        <span class="icon">
          <icon class="icon-span":name="'icon-' + iconName(group)"></icon>
        </span>
        <h2 class="sportGroupName" >
          <!--<span v-if="!mixedTeasers" >{{sportName(group)}}</span>-->
          <span class="name">{{ $t(sportName(group)) }}</span>
        </h2>

        <teaser-option v-show="currentBetSlipState<1"
                       :index="mixedTeasers ? group.IDFOSportType : index"
                       :teaserOptions="selectedTeaser"
                       :sport="group.IDFOSportType"
                       :spreads="spreadVal(group)"
                       :disabled="currentBetSlipState>=1"
                       :currentBetSlipState="currentBetSlipState"
                       :teaserSelections="teaserSelections"
                       :teasers="teasers"
                       :mixedTeasers="mixedTeasers"
                       :teaserSports="teaserSports"
                       @input="updateSelectedTeaserOption"
                       @updateSelectedTeaser="updateSelectedTeaser"
        ></teaser-option>
      </div>

      <div v-for="(selection, n) in group.Selections" class="teaserSelection"
           :class="[{'optedOut':!selectedObj[selection.IDFOSelection],
           first:n==0,
           last: n+1==teaserSelectionsPerTtype(mixedTeasers ? group.IDFOSportType : index)},
           'selected-no-' + selectedNo(mixedTeasers ? group.IDFOSportType : index), 'selection-cnt-' + teaserSelectionsPerTtype(mixedTeasers ? group.IDFOSportType : index)]"
           >
        <bet-slip-selection
          :isFor="tab"
          :selectionId="selection.IDFOSelection" :key="selection.IDFOSelection" :tab="tab"
          :betTypeStakes="{}"
          :allowedBetTypesAndReturns="{}"
          :winnings="{}"
          :multiSingles="false"
          :multiSinglesStake="0"
          :currentBetSlipState="currentBetSlipState"
          :isLive="checkLive(selection.IDFOSelection)"
          :sport="mixedTeasers ? group.IDFOSportType : index"
          :selectedTeaser="selectedTeaser"
          :teasers="teasers"
          :showInterRelated="showInterRelated(mixedTeasers ? group.IDFOSportType : index, selection.IDFOSelection)"
          :mixedTeasers="mixedTeasers"
          @removeSelection="removeSelection"
          @updateSelected="updateSelected" >
        </bet-slip-selection>

      </div>


      <div class="info msg" v-show="currentBetSlipState<1 && !gettingABTnR && (teaserSelectionsPerTtype(mixedTeasers ? group.IDFOSportType : index)<2 || selectedNo(mixedTeasers ? group.IDFOSportType : index)<2)">
        <icon name="icon-information" colorName="blue"></icon>
        {{ $t('BetSlip.tab.TEASER.info.minSelectionsNo') }}
      </div>

      <div class="info msg" v-show="currentBetSlipState<1 && !gettingABTnR && teaserSelectionsPerTtype(mixedTeasers ? group.IDFOSportType : index)>1 && selectedNo(mixedTeasers ? group.IDFOSportType : index)>1 && !allowedBetTypes.PRL[mixedTeasers ? group.IDFOSportType : index].length">
        <icon name="icon-information" colorName="blue"></icon>
        <span v-if="hasInterRelated(mixedTeasers ? group.IDFOSportType : index)">
          {{ $t('BetSlip.tab.TEASER.info.interRelated') }}
        </span>
        <span v-else >
          {{ $t('BetSlip.tab.TEASER.info.noAvailableBetTypes') }}
        </span>
      </div>

      <div v-for="betType in allowedBetTypes.PRL[mixedTeasers ? group.IDFOSportType : index]" class="itemRR betType" >
        <div class="header-TEASER">
          <!-- <span>{{selectedNo(mixedTeasers ? group.IDFOSportType : index)}} {{ $t('BetSlip.tab.TEASER.heading.PARLAY') }}</span> -->
          <span class="teaser_first" key="teaser_first">{{ $t('BetSlip.tab.TEASER.heading.PARLAY_FIRST') }}</span>
          <span class="teams_num">{{selectedNo(mixedTeasers ? group.IDFOSportType : index)}}</span>
          <span key="parly_second">{{ $t('BetSlip.tab.Standard.heading.PARLAY_SECOND') }}</span>
        </div>
        <div class="bet_content">
          <div class="odds_div">
            <span class="price_title">{{ $t('BetSlip.oddsprice') }}</span>
            <span class="price">
              {{formatOdds(betType, mixedTeasers ? group.IDFOSportType : index)}}
            </span>
          </div>
          <div class="stake-n-return">
            <stake-and-return
              :id="betType.IDFOBetType"
              :perType="'PerBetType'"
              :sport="mixedTeasers ? group.IDFOSportType : index"
            ></stake-and-return>
          </div>
        </div>
      </div>
    </div>
    <!--<br>allowedBetTypesPRL4T: {{allowedBetTypesPRL4T}}-->
    <!--<br>allowedBetTypes: {{allowedBetTypes}}-->
    <!--<br>allowedBetTypes.PRL: {{allowedBetTypes.PRL}}-->
    <!--<br>allowedBetTypesRR4T: {{allowedBetTypesRR4T}}-->
    <!--<br>allowedBetTypesAndReturns4T: {{allowedBetTypesAndReturns4T}}-->
    <!--<br>teasers: {{teasers}}-->
    <!--<br>selectedObj: {{selectedObj}}-->
    <!--<br>selectedTeaser: {{selectedTeaser}}-->
    <!--<br>teaserSelections: {{teaserSelections}}-->
    <!--<br>teaserSelections: {{teaserSelections.map.NFL}}-->
    <!--<br>betTypeStakes: {{betTypeStakes}}-->
    <!--<br>winnings: {{winnings}}-->
    <!--<br>accumulatorIds: {{accumulatorIds}}-->
    <!--<br>teaserGroups: {{teaserGroups}}-->
  </div>
</template>

<script>
  import betSlipSelection from './betslipSelection.vue'
  import store from '@/store'
  import priceFormat from '@/library/priceFormat'
  import stakeAndReturn from './stakeNreturn.vue'
  import teaserOption from './teaserOption.vue'
  import Icon from '@/components/common/Icon'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'TeaserTab',

    props: ['betsNo', 'allowedBetTypesAndReturns', 'allowedBetTypesPRL', 'allowedBetTypesRR', 'currentBetSlipState', 'gettingABTnR', 'betTypeStakes', 'winnings', 'tab'],

    components: {
      betSlipSelection,
      stakeAndReturn,
      teaserOption,
      Icon
    },

    mixins: [
      BettingOffer
    ],

    data () {
      return {
        stake: 1,
        selectedTeaser: '',
        updatingABTnR: false
      }
    },

    computed: {
      mixedTeasers () {
        return store.getters['sbBetslipState/mixedTeasers']
      },
      placeholder () {
        return {
          wager: this.$t('BetSlip.input.placeholder.wager'),
          return: this.$t('BetSlip.input.placeholder.return')
        }
      },
      selectedObj: {
        // getter
        get: function () {
          return store.getters['sbBetslipState/optedInTeaser']
        },
        // setter
        set: function (newValue) {
//          console.log('selected newValue: ' + newValue)
        }
      },

      teaserGroups () {
        return store.getters['sbBetslipState/teaserGroups']
      },
      handicapChanged () {
        return store.getters['sbBetslipState/handicapChanged']
      },
      spreads () {
        return store.getters['sbBetslipState/teaserSpreads']
      },
      teaserSports () {
        return store.getters['sbBetslipState/teaserSports']
      },
      teaserSportsList () {
        return this.mixedTeasers ? ['MIXED'] : this.teaserSports
      },
      sportTypes () {
        return store.getters['sbBetslipState/teaserSports']
      },
      doUpdateTeaser () {
        return store.getters['sbBetslipState/doUpdateTeaser']
      },
      betslipSelections () {
        return store.getters['sbBetslipState/betslipSelections']
      },
      teaserSelections () {
        return store.getters['sbBetslipState/teaserSelections']
      },
      allowedBetTypesAndReturns4T () {
        return store.getters['sbBetslipState/allowedBetTypesAndReturns4T']
      },
      allowedBetTypesPRL4T () {
        return store.getters['sbBetslipState/allowedBetTypesPRL4T']
      },
      allowedBetTypesRR4T () {
        return store.getters['sbBetslipState/allowedBetTypesRR4T']
      },
      accumulatorIds () {
        return store.getters['sbBetslipState/accumulatorIds']
      },
      allowedBetTypes () {
//        console.log('TEASER allowedBetTypes')
        var accumulatorIds = this.accumulatorIds
        var PRL = {}
//        for (var i = 0; i <= 7; i++) {
        for (var i in this.allowedBetTypesAndReturns4T) {
          PRL[i] = this.allowedBetTypesAndReturns4T[i].AllowedBetTypes.filter(function (bT) {
//              return bT.BetTypeInstruction === 'A'
            return accumulatorIds.indexOf(bT.IDFOBetType) > -1
          })
        }
        //
        PRL.MIXED = this.allowedBetTypesAndReturns4T.MIXED.AllowedBetTypes.filter(function (bT) {
//              return bT.BetTypeInstruction === 'A'
          return accumulatorIds.indexOf(bT.IDFOBetType) > -1
        })
        //
        return {PRL: PRL}
        /*
        return {
          PRL: {
            NFL: this.allowedBetTypesAndReturns4T.NFL.AllowedBetTypes.filter(function (bT) {
//              return bT.BetTypeInstruction === 'A'
              return accumulatorIds.indexOf(bT.IDFOBetType) > -1
            }),
            BASKETBALL: this.allowedBetTypesAndReturns4T.BASKETBALL.AllowedBetTypes.filter(function (bT) {
//              return bT.BetTypeInstruction === 'A'
              return accumulatorIds.indexOf(bT.IDFOBetType) > -1
            })
          }
        }
        */
      },
      teasers () {
        return store.getters['sbBetslipState/teasers']
      },
      selectedTeaser_: {
        get: function () {
          return store.getters['sbBetslipState/activeTeaser']
        },
        set: function (newVal) {
          store.commit('sbBetslipState/setActiveTeaser', newVal)
        }
      },
      activeTeaser () {
        // return store.getters['sbBetslipState/activeTeaser']
        return store.getters['sbBetslipState/activeTeaserByGroup']
      },
      selectionNo () {
//        console.log('selectionNo')
        var n = 0
        if (this.mixedTeasers) {
          return this.teaserSelections.MIXED.length
        }
        for (var i = 0; i <= 7; i++) {
          if (this.teaserSelections[i]) {
            n += this.teaserSelections[i].length
          }
        }
        return n
      },
      selectionNoNFL () {
        return this.teaserSelections.NFL.length
      },
      selectionNoBKB () {
        return this.teaserSelections.BASKETBALL.length
      },
      interRelated () {
//        console.log('interRelated')
        var self = this
        var ir = {NFL: {}, BASKETBALL: {}, MIXED: {}}

        var fn = function (sport) {
//          var className = ''
          ir[sport] = {}
          if (self.teaserSelectionsPerTtype(sport)) {
            self.teaserSelections[sport].forEach(function (sId) {
              var s = sId
              if (!sId.idfoselection) {
                s = store.getters['sbBetslipState/getStoredSelectionById'](sId)
              }
              if (s && s.interRelated) {
                ir[sport][s.interRelated] = ir[sport][s.interRelated] || []
                ir[sport][s.interRelated].push(s.idfoselection)
              }
            })
          }
        }
        //
        if (this.teaserGroups && this.teaserGroups.length) {
          for (var i in this.teaserGroups) {
            if (this.mixedTeasers && this.teaserGroups.length === 1 && this.teaserGroups[i].IDFOSportType === 'MIXED') {
              fn('MIXED')
            } else {
              fn(i)
            }
          }
        }
        //
        return ir
      },
      liveSelections () {
        return store.getters['sbBetslipState/liveSelections']
      }
    },

    methods: {
      iconName (group) {
        if (this.mixedTeasers) {
          return group.iconName || ''
        }
        return group.IDFOSportType.split(' ').join('').toLowerCase()
      },
      groupId (group) {
        return group.IDFOSportType.split(' ').join('').toUpperCase()
      },
      sportName (group) {
        if (this.mixedTeasers) {
          return group.sportName || 'BetSlip.tab.TEASER.option.label.MIXED'
        }
        var sports = group.Sports.split(',')
        return sports.length === 1 ? sports[0] : group.IDFOSportType
      },
      spreadVal (group) {
        var spreads = {}
        var spread
        for (var i = 1; i <= 3; i++) {
          spread = group['Spread' + i]
          if (spread > 0) {
            spread = '+ ' + spread
          }
          spreads['T' + i] = spread
        }
        return spreads
      },
      checkLive (selection) {
        return this.liveSelections.indexOf(selection) >= 0
      },
      hasLiveSelection (sport) {
        var self = this
        return self.teaserSelections[sport].filter(function (s) {
          return self.selectedObj[s.idfoselection] && self.liveSelections.indexOf(s.idfoselection) >= 0
        }).length
      },

      teaserSelectionsPerTtype (sport) {
//        console.log('teaserSelectionsPerTtype: ' + sport)
        if (this.mixedTeasers) {
          return this.selectedTeaser && this.selectedTeaser[sport] &&
          this.teaserSelections && this.teaserSelections.map && this.teaserSelections.map[sport] &&
          this.teaserSelections.map[sport][this.selectedTeaser[sport]] ? this.teaserSelections.map[sport][this.selectedTeaser[sport]].length : 0
        }
        //
        var tt = this.selectedTeaser[sport]
        if (!tt) {
          return 0
        }
        var tn = tt.split('')[1]
        var selections = []
        var selection = {}
        var src = this.teaserGroups && this.teaserGroups[sport] && this.teaserGroups[sport].Selections ? this.teaserGroups[sport].Selections : []
        for (var i = 0; i < src.length; i++) {
          var s = src[i]
          selection = s['Item' + tn]
          if (selection) {
            selections.push(selection)
          }
        }
        return selections.length
      },
      isForTeaserType (idfoselection, sport, selectedTeaser) {
        return true
        /*
        return store.getters['sbBetslipState/isForTeaserType']({
          idfoselection: idfoselection,
          sport: sport,
          selectedTeaser: selectedTeaser[sport]
        })
        */
        /*
        return this.selectedTeaser && this.selectedTeaser[sport] &&
        this.teaserSelections && this.teaserSelections.map && this.teaserSelections.map[sport] &&
        this.teaserSelections.map[sport][selectedTeaser[sport]] ? this.teaserSelections.map[sport][selectedTeaser[sport]].indexOf(idfoselection) > -1 : false
        */
      },
      /*
      showInterRelated (sport, idfoselection) {
//        console.log('showInterRelated')
        var selection
        this.teaserSelections[sport].find(function (sId) {
          selection = store.getters['sbBetslipState/getStoredSelectionById'](sId)
          return selection && selection.idfoselection === idfoselection
        })
        var irId = selection && selection.interRelated
        if (typeof irId === 'undefined') {
          return false
        }
        return this.interRelated && this.interRelated[sport] && this.interRelated[sport][irId] && this.interRelated[sport][irId].length > 1
      },
      */
      showInterRelated (sportId, idfoselection) {
        var sports = [sportId]
        var sport
        sports = this.teaserSports
        if (this.mixedTeasers) {
          sports = this.teaserSports
        }
        //
        for (var sp = 0; sp < sports.length; sp++) {
          sport = sports[sp]
          var selection = this.teaserSelections[sport].find(function (s) {
            return s === idfoselection || s.idfoselection === idfoselection
          })
          if (selection) {
            break
          }
        }
        if (!selection) {
//          console.log('No IRtd selection')
        }
        var irId = selection && selection.interRelated
        if (typeof irId === 'undefined') {
          return false
        }
        let showInterRelated = this.interRelated && this.interRelated[sportId] && this.interRelated[sportId][irId] && this.interRelated[sportId][irId].length > 1
//        console.log('showInterRelated (' + idfoselection + '): ' + showInterRelated)
        return showInterRelated
      },
      hasInterRelated (sport) {
//        console.log('hasInterRelated (' + sport + ')?')
        var self = this
        var compareNumbers = function (a, b) {
          return b - a
        }
//        return !!(this.interRelated && this.interRelated[sport] && Object.keys(this.interRelated[sport]).length > 1)
        if (this.interRelated && this.interRelated[sport] && Object.keys(this.interRelated[sport]).length) {
          return Object.keys(this.interRelated[sport]).map(function (i) {
            return self.interRelated[sport][i].length
          }).sort(compareNumbers)[0] > 1
        }
        return false
      },

      removeSelection () {

      },
      formatOdds (bT, sport) {
        var betType = this.allowedBetTypesAndReturns4T[sport].PotentialReturns.PerBetType[bT.IDFOBetType]
        var odds = betType.PotentialReturn - betType.UnitCount + 1
        var formatted = priceFormat.formatOdds(odds, 2)
        return formatted
      },
      selectedNo (index) {
        if (!this.mixedTeasers) {
          return this.createSelectionsPerGroup(this.teaserGroups[index], index).length
        }
//
        var sport = index
        var c = 0
        var selection
        for (var i in this.teaserSelections[sport]) {
          selection = this.teaserSelections[sport][i]
          if (this.isForTeaserType(selection.idfoselection, sport, this.selectedTeaser)) {
            c += this.selectedObj[selection.idfoselection] ? 1 : 0
          }
        }
        return c
      },
      updateSelectedTeaserOption (data) {
//        console.log('updateSelectedTeaserOption')
        this.setTeaserType(data)
        // this.getABTnR4T(data.sport)
        this.getABTnRperGroup(this.teaserGroups[data.index], data.index)
      },
      updateSelectedTeaser (id) {
//        console.log('updateSelectedTeaser: ' + id)
        var t = this.selectedTeaser[id]
        if (t) {
          this.setTeaserType(id, t)
          this.getABTnR4T(id)
        } else {
          this.clearABTnr()
        }
      },
      updateSelected (id) {
//        console.log('updateSelected ' + id)
        this.$emit('updateSelected', id)
//        this.getAllowedBetTypesAndReturns4Teasers(id)
        this.getABTnRperGroup(this.teaserGroups[id], id)
      },
      placeBet (id) {
        this.$emit('placeBet', id)
      },
      setTeaserType (data) {
//        this.setTeaserType = t
//        console.log('setTeaserType: ' + t)
        store.commit('sbBetslipState/setActiveTeaser', [this.mixedTeasers ? data.sport : data.index, data.t])
        this.$emit('setTeaserType', this.selectedTeaser)
      },
      createSelections (sport) {
        var self = this
        //
        var sports = []
        if (sport === 'MIXED') {
          sports = self.teaserSports
        } else {
          sports = [sport]
        }
        console.log('createSelections sports: ' + sports)
        //
        var selections = []
        var selection = {}
        var src = this.teaserSelections[sport]
        for (var i = 0; i < src.length; i++) {
          var s = src[i]
          selection = this.teasers[this.selectedTeaser[sport]][s.idfoselection]
          if (selection && this.isForTeaserType(s.idfoselection, sport, this.selectedTeaser)) {
            selections.push(selection)
          }
        }
        selections = selections.filter(function (s) {
          return self.selectedObj[s.idfoselectionsource]
        })
//        console.log('selections:')
//        console.log(selections)
        return selections
      },

      getAllowedBetTypesAndReturns4Teasers (sport) {
        return false
        /*
        var self = this
        self.updatingABTnR = true
        store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns4Teasers', [sport, self.createSelections(sport)]).then(
          function () {
            self.updatingABTnR = false
          }
        )
        */
      },

      getABTnR4T (sport) {
//        console.log('TEASER: getABTnR4T')
        return {}
        /*
        var self = this
        if (this.currentBetSlipState < 1) {
          self.updatingABTnR = true
          store.dispatch('sbBetslipState/getTeasers', [self.selectedTeaser[sport], sport]).then(
            function (teasers) {
//              console.log('teasers:')
//              console.log(teasers)
              if (teasers) {
                self.getAllowedBetTypesAndReturns4Teasers(sport)
              }
            }
          )
        }
        */
      },
      getABTnR4Ts () {
//        this.getABTnR4T('NFL')
//        this.getABTnR4T('BASKETBALL')
        this.getABTnRperGroups()
      },

      createSelectionsPerGroup (group, index) {
        var self = this
        var tt = this.selectedTeaser[index]
        var tn = tt.split('')[1]
        var selections = []
        var selection = {}

        var groupArr = []
        if (group && group.Selections) {
          groupArr = [group]
        } else {
          groupArr = group
        }
        for (var g = 0; g < groupArr.length; g++) {
          var src = groupArr[g].Selections
          if (src && src.length) {
            for (var i = 0; i < src.length; i++) {
              var s = src[i]
              selection = s['Item' + tn]
              if (selection) {
                selections.push(selection)
              }
            }
          }
        }

        selections = selections.filter(function (s) {
          return self.selectedObj[s.idfoselectionsource]
        })
//        console.log('selections:')
//        console.log(selections)
        return selections
      },

      getABTnRperGroup (group, index) {
        var self = this
        self.updatingABTnR = true

        if (self.mixedTeasers) {
          index = 'MIXED'
          group = self.teaserGroups
        }

        var sport = store.getters['sbBetslipState/teaserGroupId'](group)
//        console.log('-> getAllowedBetTypesAndReturns4Teasers ' + sport)
        store.dispatch('sbBetslipState/getAllowedBetTypesAndReturns4Teasers', [index, self.createSelectionsPerGroup(group, index), sport]).then(
          function () {
            self.updatingABTnR = false
          }
        )
      },

      getABTnRperGroups () {
        for (var i in this.teaserGroups) {
          this.getABTnRperGroup(this.teaserGroups[i], i)
        }
      },

      clearABTnr () {
        store.commit('sbBetslipState/clearAllowedBetTypesAndReturns4Teasers')
      },

      betSlipPlacementData () {
        // PARLAY
        // this.multiSingles
        var betTypes = []
        var betType = 'S'
        if (this.tab === 'S' || this.tab === 'PARLAY') {
          betType = (this.multiSingles && this.allowedBetTypesSING[0]) || {IDFOBetType: 'S'}
          betTypes.push(betType)
          if (this.allowedBetTypesPRL && this.allowedBetTypesPRL[0]) {
            betTypes.push(this.allowedBetTypesPRL[0])
          }
        }
        if (this.tab === 'TEASER') {
          betType = this.allowedBetTypesPRL[0] || {IDFOBetType: 'A'}
          betTypes.push(betType)
        }
        if (this.tab === 'RR') {
          betType = this.activeRR
          betTypes.push(betType)
        }
        var data = {
          id: betTypes,
          tab: this.tab,
          betTypeStakes: this.betTypeStakes,
          multiSingles: this.multiSingles
        }
        return data
      },
      getTeaserGroups () {
        var self = this
        store.dispatch('sbBetslipState/getTeaserGroups', 'ALL').then(function () {
          self.getABTnR4Ts()
        })
      }
    },

    watch: {
      doUpdateTeaser: function () {
        this.getABTnR4Ts()
      },
      handicapChanged: function (newVal, oldVal) {
//        console.log('Watch TEASER handicapChanged: ' + oldVal + ' => ' + newVal)
//        this.getABTnR4Ts()
      },
      selectionNo: function (newVal) {
        this.getABTnR4Ts()
      },
      selectionNoNFL: function (newVal) {
        if (newVal && this.selectedTeaser) {
//          console.log('triggered by selectionNoNFL: ' + newVal)
          this.getABTnR4T('NFL')
        }
      },
      selectionNoBKB: function (newVal) {
        if (newVal && this.selectedTeaser) {
//          console.log('triggered by selectionNoBKB: ' + newVal)
          this.getABTnR4T('BASKETBALL')
        }
      }
    },

    created () {
//      console.log('created Teaser Tab')
      this.selectedTeaser = this.activeTeaser
      this.$emit('setTeaserType', this.selectedTeaser)
      if (store.getters['sbBetslipState/pendingGetTeaserGroups']) {
        this.getTeaserGroups()
      } else {
        this.getABTnR4Ts()
      }
    },
    mounted () {
//      console.log('Mounted Teaser Tab')
    }
  }
</script>

<style lang="stylus" scoped>
  color-border = #CFD6DB

  .sport-container
    background: #fff
    border: solid 1px color-border
    border-radius: 5px
    margin-bottom: 4px

  .betType
    background-color: #F0F3F8
    border-radius: 0 0 4px 4px
    padding: 0px
    margin: 0
    >>>.money-input
      background: #ffffff

    .header-TEASER
      font-weight: bold
      padding: 5px 12px
      color: #000
      border: 0px solid #CCC
      border-radius: 5px 5px 0 0
      font-size: 14px
      color: #06283b
      .price
        color: #2396fc

    .stake-n-return
      padding: 5px 6px
      border-radius: 0 0 5px 5px


  .align-center
    text-align: center

  .btn-container
    background-color: #999

  .btn
    min-width: 80%
    min-height: 40px
    text-transform: none
    padding: 5px
    height: auto

  .optedOut
    background-color: #e0e0e0
    color: gray


  .itemRR
    margin-bottom: 0
    .header-RR
      padding: 5px 5px 2px

  .teaser-option-container
    display: flex
    align-items: center
    border-bottom: solid 1px color-border
    padding: 8px 12px
    display: flex
    background: #fff
    border-radius: 5px 5px 0 0
    .icon-span
      color white
    .sportGroupName
      .name
        color white
    .icon,
    h2,
    .teaser-option
      flex: 1
      flex-basis: auto

    h2
      min-height: auto
    .icon,
    .teaser-option
      flex-grow: 0

    .icon
      margin-right: 12px

      >>> .css
        width: 20px
        height: 20px

    h2
      margin: 0

  .teaserSelection
    .bsSelection
      >>> .selection
        border: none


    border-style: solid
    border-width: 0 0 1px
    border-color: color-border

    &:last-child
      border: none

</style>



// WEBPACK FOOTER //
// src/components/sports/betslip/TeaserTab.vue